import { MenuItem, toast } from "../../vendor/ds-react";
import {
  ContextMenuItem,
  ContextMenuSeparator,
} from "../../vendor/src/features/remotion-editor/editor/context-menu";
import {
  useCurrentStateAsRef,
  useFullState,
  useWriteContext,
} from "../../vendor/src/features/remotion-editor/editor/utils/use-context";
import {
  isMergedAudio,
  mergeAudio,
  selectedAudioForMerge,
  unmergeAudio,
} from "./audio-merge";
import { editorUserMessage } from "../../protocol/user-message";
export function AudioMergeContextMenu({ clipId }: { clipId: string }) {
  const state = useFullState(),
    ref = useCurrentStateAsRef(),
    { setState } = useWriteContext();
  const merged = isMergedAudio(state.undoableState, clipId);
  if (state.undoableState.items[clipId]?.type !== "audio" && !merged)
    return null;
  const ids = selectedAudioForMerge(state, clipId);
  const run = (split: boolean) => {
    try {
      const before = ref.current;
      const after = split
        ? unmergeAudio(before, clipId)
        : mergeAudio(before, selectedAudioForMerge(before, clipId), () =>
            crypto.randomUUID(),
          );
      setState({
        commitToUndoStack: true,
        update: (prev) =>
          prev.undoableState === before.undoableState
            ? {
                ...prev,
                undoableState: after.undoableState,
                selectedItems: after.selectedItems,
                activeGroupId: null,
                inspectedGroupMemberId: null,
              }
            : prev,
      });
    } catch (error) {
      toast({
        type: "error",
        description: editorUserMessage(
          error,
          "음성 병합을 완료하지 못했습니다.",
        ),
        toastOptions: { position: "top-center" },
      });
    }
  };
  return (
    <>
      <ContextMenuSeparator />
      <ContextMenuItem
        disabled={ids.length < 2}
        onPointerDown={(e) => e.stopPropagation()}
        onSelect={() => run(false)}
      >
        <MenuItem
          size="md"
          showLeadingIcon={false}
          text="음성 병합"
          className="w-full"
        />
      </ContextMenuItem>
      {merged && (
        <ContextMenuItem
          onPointerDown={(e) => e.stopPropagation()}
          onSelect={() => run(true)}
        >
          <MenuItem
            size="md"
            showLeadingIcon={false}
            text="음성 병합 해제"
            className="w-full"
          />
        </ContextMenuItem>
      )}
    </>
  );
}
